<template>
    <div class="answer-item-wrapper">
        <div v-if="item.postType === 2 || item.images && item.images.length > 1 || item.images.length === 0" class="answer-item-y">
            <div class="title clamp-content clamp-content-1">{{ item.title }}</div>
            <div v-if="item.head_part" class="content clamp-content clamp-content-2">{{ intro }}</div>
            <div v-if="item.postType === 2" class="media">
                <div class="video">
                    <video-box
                        :src="item.video_info.video_url"
                        :poster="item.video_info.video_image"
                        :duration="item.video_info.video_duration"
                        :index="index"
                        :autoplay="false"
                        :source="0"
                    />
                </div>
            </div>
            <div v-else-if="item.images && item.images.length > 0" class="media">
                <div class="pics">
                    <div v-for="(i, k) of item.images" :key="k">
                        <img v-lazy="i.url">
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="answer-item-x">
            <div class="left">
                <div class="title clamp-content clamp-content-1">{{ item.title }}</div>
                <div class="content clamp-content clamp-content-2">{{ item.head_part }}</div>
            </div>
            <div class="right">
                <img v-lazy="item.images[0].url">
            </div>
        </div>
        <div class="bottom">
            <img v-lazy="item.portrait">
            <div class="user">{{ item.user_name }}</div>
            <div class="time">{{ item.publish_time }}</div>
        </div>
    </div>
</template>
<script>
import VideoBox from './app-video-box';
export default {
    components: {
        VideoBox,
    },
    props: {
        item: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            index: 98,
        };
    },
    computed: {
        intro() {
            return this.item.postType === 2 ? this.item.video_info.video_intro : this.item.head_part;
        },
    },
};
</script>
<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/border";

    $design-width: 1242;
    $max-device-width: 768px;

    html {
        @include root-font-size();
    }

    html, body {
        padding: 0;
        margin: 0;
    }

    .answer-item-wrapper {
       @include border-single(bottom, 1px, #E0E0E0);
       padding-bottom: px2rem(45);
       margin-bottom: px2rem(45);
    }

    .title {
        font-weight: bold;
        margin-bottom: px2rem(40);
    }
    .content {
        margin-bottom: px2rem(45);
    }
    .answer-item-y {
        color: #1f1f1f;
        font-size: px2rem(48);
        .media {
            margin-bottom: px2rem(48);
            .pics {
                display: flex;
                &>div {
                    width: px2rem(352);
                    height: px2rem(235);
                    margin-right: px2rem(24);
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: px2rem(26);
                    }
                }
            }
            .video {
                width: 100%;
                height: px2rem(621);
            }
        }
    }
    .answer-item-x {
        color: #1f1f1f;
        font-size: px2rem(48);
        height: px2rem(235);
        display: flex;
        justify-content: space-between;
        margin-bottom: px2rem(48);
        .right {
            width: px2rem(352);
            height: 100%;
            flex-shrink: 0;
            img {
                width: 100%;
                height: 100%;
                border-radius: px2rem(26);
            }
        }
    }
    .bottom {
        display: flex;
        align-items: center;
        font-size: px2rem(42);
        // color: #858585;
        color: #1f1f1f;
        img {
            width: px2rem(48);
            height: px2rem(48);
            border-radius: 50%;
            margin-right: px2rem(18);
        }
        .time {
            margin-left: auto;
        }
    }
</style>